import React from 'react';

const Settings: React.FC = () => {
  return <div>Configure your settings here.</div>;
};

export default Settings;
